<ng-container [formGroup]="storeForm">
  <div>
    <mat-form-field appearance="fill">
      <mat-label>{{ nameLabel }}</mat-label>
      <input data-test="storeName" matInput formControlName="name" required />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>{{ descriptionLabel }}</mat-label>
      <textarea
        data-test="storeDescription"
        matInput
        matTooltip="Parlez-nous de vous (expériences, valeurs, etc.) Évitez d’inscrire des informations personnelles (adresse, téléphone)"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        formControlName="description"
      ></textarea>
    </mat-form-field>
  </div>
  <app-image-upload formControlName="imageInput"></app-image-upload>
  <br />
</ng-container>
